import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import DropOffChart from "./DropOffChart";
import ConversionChart from "./ConversionChart";
import DevicesChart from "./DevicesChart";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { getUTM } from "../../../config/service";

const AnalyticsCharts = () => {
  const { t } = useTranslation();

  const [utm, setUtm] = useState([]);
  const [selectedUtm, setSelectedUtm] = useState(null);

  const [activeTab, setActiveTab] = useState("dropoff");
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [isLoader, setIsLoader] = useState(true);

  const handleChange = async (name, value) => {
    if (name === "fromDate") {
      if (!value) {
        setFromDate(null);
      }
      setFromDate(value);
    }
    if (name === "toDate") {
      if (!value) {
        setToDate(null);
      }
      setToDate(value);
    }
  };

  const handleSelectUTM = (option) => {
    setSelectedUtm(option);
  };

  const getAnalyticUTM = async () => {
    try {
      const response = await getUTM();
      setUtm(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAnalyticUTM();
  }, []);

  const handleTab = (value) => {
    setFromDate(null);
    setToDate(null);
    setActiveTab(value);
  };

  return (
    <div className="analytics-chart">
      <div className="toggleDiv">
        <div className="tab-grid">
          <span
            onClick={() => {
              handleTab("dropoff");
            }}
            className={activeTab == "dropoff" ? "spanActive" : "toggle "}
          >
            {t("Drop-Off")}
          </span>
          <span
            onClick={() => {
              handleTab("conversion");
            }}
            className={activeTab == "conversion" ? "spanActive" : "toggle "}
          >
            {t("Conversion")}
          </span>
          <span
            onClick={() => {
              handleTab("devices");
            }}
            className={activeTab == "devices" ? "spanActive" : "toggle "}
          >
            {t("Devices")}
          </span>
        </div>
      </div>
      <div className="chart-filter-grid">
        <div className="idf-report-grid ">
          <Form.Group className="form-group">
            <Form.Label>{t("UTM")}</Form.Label>
            <select
              name="utm"
              value={selectedUtm?.value || ""}
              onChange={(e) =>
                handleSelectUTM(
                  e.target.value
                    ? { value: e.target.value, label: e.target.value }
                    : null,
                )
              }
              className="form-type form-control"
              disabled={isLoader}
            >
              <option value="">Select</option>
              {utm.map((value, i) => (
                <option value={value} key={i}>
                  {value}
                </option>
              ))}
            </select>
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>From Date</Form.Label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={fromDate}
              name="fromDate"
              onChange={(event) => handleChange("fromDate", event)}
              placeholderText="DD/MM/YYYY"
              className="datePicker"
              endDate={new Date()}
              maxDate={new Date()}
              disabled={isLoader}
            />
          </Form.Group>
          <Form.Group className="form-group">
            <Form.Label>To Date</Form.Label>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={toDate}
              name="toDate"
              onChange={(event) => handleChange("toDate", event)}
              placeholderText="DD/MM/YYYY"
              endDate={new Date()}
              maxDate={new Date()}
              className="datePicker"
              popperPlacement="top-start"
              disabled={isLoader}
            />
          </Form.Group>
        </div>
      </div>
      {activeTab === "dropoff" && (
        <DropOffChart
          utm={selectedUtm}
          toDate={toDate}
          fromDate={fromDate}
          isLoader={isLoader}
          setIsLoader={setIsLoader}
          activeTab={activeTab}
        />
      )}
      {activeTab === "conversion" && (
        <ConversionChart
          utm={selectedUtm}
          toDate={toDate}
          fromDate={fromDate}
          isLoader={isLoader}
          setIsLoader={setIsLoader}
          activeTab={activeTab}
        />
      )}
      {activeTab === "devices" && (
        <DevicesChart
          utm={selectedUtm}
          toDate={toDate}
          fromDate={fromDate}
          isLoader={isLoader}
          setIsLoader={setIsLoader}
          activeTab={activeTab}
        />
      )}
    </div>
  );
};

export default AnalyticsCharts;
